module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "ch00_fm03_copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2012 The Johns Hopkins University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("All rights reserved. Published 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Printed in the United States of America on acid-free paper")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("2    4    6    8    9    7    5    3    1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("2715 North Charles Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Baltimore, Maryland 21218-4363")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Kairoff, Claudia Thomas.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Anna Seward and the end of the eighteenth century /"), _c('br'), _vm._v("Claudia Thomas Kairoff.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("p.    cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("ISBN-13: 978-1-4214-0328-1 (acid-free paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("ISBN-10: 1-4214-0328-5 (acid-free paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("1. Seward, Anna, 1742–1809—Criticism and interpretation."), _c('br'), _vm._v("2. England—Intellectual life—18th century. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("PR3671.S7Z74     2012")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("821′.6—dc22         2011019914")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“Anna Seward and the Sonnet: Milton’s Champion” was originally"), _c('br'), _vm._v("published in "), _c('em', [_vm._v("Aphra Behn Online")]), _vm._v(" 1 (2011) and is reprinted here"), _c('br'), _vm._v("with permission of the editors.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Special discounts are available for bulk purchases of this book")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_c('em', [_vm._v("For more information, please contact Special Sales at 410-516-6936"), _c('br'), _vm._v("or specialsales@press.jhu.edu")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press uses environmentally friendly book"), _c('br'), _vm._v("materials, including recycled text paper that is composed of at least"), _c('br'), _vm._v("30 percent post-consumer waste, whenever possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e17ba4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_copy.vue
// module id = 66
// module chunks = 0